import { PropsWithChildren } from 'react';

import { PropsWithTestAttribute } from 'types/testAttribute';

import { Tooltip } from '../Tooltip';

import { TypographyStyled } from './Typography.styles';
import { TypographyProps } from './types';

/**
 * Typography component.
 */

export const Typography = ({
  children,
  variant = 'body',
  className,
  title,
  align,
  color,
  as,
  maxLine,
  datax,
  whiteSpace,
  lineHeight,
  onClick,
}: TypographyProps & PropsWithChildren & PropsWithTestAttribute) => (
  <Tooltip placement="top-start" title={title}>
    <TypographyStyled
      align={align}
      as={as}
      className={className}
      color={color}
      datax={datax}
      lineHeight={lineHeight}
      maxLine={maxLine}
      variant={variant}
      whiteSpace={whiteSpace}
      onClick={onClick}
    >
      {children}
    </TypographyStyled>
  </Tooltip>
);
